import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ValidGradingRankCode } from '../../../../shared/interface/valid-grading-rank-code.interface';
import { AlertService } from '../../../../shared/services/alert.service';
import { CrudPromiseService } from '../../../../shared/services/crud-promise.service';

@Injectable({
    providedIn: 'root'
})
export class FacultyCategoryService extends CrudPromiseService<ValidGradingRankCode> {
    constructor(protected http: HttpClient, protected alert: AlertService) {
        super(http, 'validGradingRankCode', alert);
    }
}
